import React from "react";
import { twMerge } from "tailwind-merge";
import { bool, func, string } from "prop-types";

const Switch = ({
  ariaLabel,
  checked,
  className,
  isHorizontal,
  onChange,
  ...props
}) => {
  return (
    <label
      aria-label={ariaLabel}
      className={twMerge(
        "block max-h-12 max-w-6 relative cursor-pointer",
        isHorizontal && "-rotate-90"
      )}
      data-id="journey-switch"
    >
      <input
        className={twMerge(
          "bg-primaryDarkAccent appearance-none rounded-full cursor-pointer h-12 w-6",
          "transition duration-150 focus:outline-0",
          "ring-1 ring-white hover:ring-2",
          className?.body
        )}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        {...props}
        aria-label={ariaLabel}
      />
      <div
        className={twMerge(
          "bg-white rounded-full size-5 absolute left-1/2 top-0 transition duration-300 -translate-x-1/2",
          checked ? "translate-y-[1.625rem]" : "translate-y-[0.125rem]",
          className?.slider
        )}
      />
    </label>
  );
};

Switch.propTypes = {
  checked: bool.isRequired,
  onChange: func.isRequired,
  ariaLabel: string,
  className: string,
  isHorizontal: bool,
};

export default Switch;
